// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__-VawF","label":"Labeled_label__2clbQ","divider":"Labeled_divider__28rLg"};